import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
}), 'PowerInputSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PowerInputSharp.js
// module id = 5581
// module chunks = 2